/* ==========================================================================
   Wunderfahrrad – Produktbilder-Galerie: Zoom + professionelle Navigation
   Datei: assets/wf-gallery-zoom.js (neu anlegen im Theme)
   Einbindung: {{ 'wf-gallery-zoom.js' | asset_url | script_tag }}
   auf der Produktseite (z. B. im Produkt-Template, nach dem Galerie-Markup),
   ODER global in theme.liquid vor </body>. Läuft nur, wenn .gallery_big
   auf der Seite existiert, also unschädlich auf anderen Seiten.

   Voraussetzung: PhotoSwipe v5 wird per CDN geladen (siehe unten, wird von
   diesem Skript automatisch nachgeladen – keine weitere Einbindung nötig).

   Funktionsweise:
   - Baut aus den vorhandenen Galerie-Bildern (.gallery_big .swiper-slide img)
     eine Bildliste für PhotoSwipe (Lightbox mit Zoom, Pfeil-Navigation,
     Wischen auf Mobile).
   - Fügt zusätzlich direkt auf dem Hauptbild dezente Pfeile ein, die den
     bereits vorhandenen Swiper der Seite weiterschalten (slideNext/slidePrev
     sind Kern-Swiper-Methoden und funktionieren unabhängig davon, ob das
     Navigations-Modul im Theme aktiviert wurde – daher sicher, ohne die
     bestehende Galerie-Konfiguration anzufassen oder zu riskieren).
   - Rührt die bestehende Swiper-Initialisierung des Themes NICHT an, um die
     vorhandene Thumb-Synchronisierung nicht zu gefährden.
   ========================================================================== */
(function () {
  'use strict';

  function loadPhotoSwipeAssets(callback) {
    if (window.PhotoSwipe && window.PhotoSwipeLightbox) {
      callback();
      return;
    }
    var cssId = 'wf-pswp-css';
    if (!document.getElementById(cssId)) {
      var link = document.createElement('link');
      link.id = cssId;
      link.rel = 'stylesheet';
      link.href = 'https://cdn.jsdelivr.net/npm/photoswipe@5.4.4/dist/photoswipe.css';
      document.head.appendChild(link);
    }
    var script = document.createElement('script');
    script.src = 'https://cdn.jsdelivr.net/npm/photoswipe@5.4.4/dist/umd/photoswipe.umd.min.js';
    script.onload = function () {
      var script2 = document.createElement('script');
      script2.src = 'https://cdn.jsdelivr.net/npm/photoswipe@5.4.4/dist/umd/photoswipe-lightbox.umd.min.js';
      script2.onload = callback;
      document.head.appendChild(script2);
    };
    document.head.appendChild(script);
  }

  function naturalSizeOf(url) {
    return new Promise(function (resolve) {
      var img = new Image();
      img.onload = function () {
        resolve({ w: img.naturalWidth || 1600, h: img.naturalHeight || 1200 });
      };
      img.onerror = function () {
        resolve({ w: 1600, h: 1200 });
      };
      img.src = url;
    });
  }

  function largestFromSrcset(imgEl) {
    var srcset = imgEl.getAttribute('srcset') || imgEl.getAttribute('data-srcset');
    if (!srcset) return imgEl.currentSrc || imgEl.src;
    var candidates = srcset.split(',').map(function (s) {
      var parts = s.trim().split(' ');
      return { url: parts[0], width: parseInt(parts[1] || '0', 10) };
    });
    candidates.sort(function (a, b) { return b.width - a.width; });
    return candidates[0] ? candidates[0].url.replace(/^\/\//, 'https://') : imgEl.src;
  }

  async function init() {
    var galleryBig = document.querySelector('.gallery_big');
    if (!galleryBig) return; // nur auf der Produktseite aktiv

    var slides = Array.from(galleryBig.querySelectorAll('.swiper-slide img'));
    if (!slides.length) return;

    // Bildliste für die Lightbox aufbauen (in Originalauflösung, kein Zuschnitt)
    var items = await Promise.all(
      slides.map(async function (imgEl) {
        var full = largestFromSrcset(imgEl);
        var size = await naturalSizeOf(full);
        return { src: full, w: size.w, h: size.h, alt: imgEl.alt || '' };
      })
    );

    loadPhotoSwipeAssets(function () {
      var lightbox = new window.PhotoSwipeLightbox({
        dataSource: items,
        pswpModule: window.PhotoSwipe,
        wheelToZoom: true,
        zoom: true,
        arrowKeys: true,
        showHideAnimationType: 'fade',
                tapAction: function (point, originalEvent) {
          var target = originalEvent && originalEvent.target;
          if (target && target.classList && target.classList.contains('pswp__img')) {
            this.element.classList.toggle('pswp--ui-visible');
          } else {
            this.close();
          }
        }
      });
      lightbox.init();

      // Zoom-Hinweis-Icon einfügen
      if (!galleryBig.querySelector('.wf-zoom-hint')) {
        var hint = document.createElement('div');
        hint.className = 'wf-zoom-hint';
        hint.innerHTML =
          '<svg viewBox="0 0 24 24" fill="none" stroke="#3e774a" stroke-width="2"><circle cx="11" cy="11" r="7"/><line x1="21" y1="21" x2="16.65" y2="16.65"/><line x1="11" y1="8" x2="11" y2="14"/><line x1="8" y1="11" x2="14" y2="11"/></svg>';
        galleryBig.appendChild(hint);
      }

      // Klick auf das Hauptbild öffnet die Lightbox beim aktuell aktiven Bild
      galleryBig.addEventListener('click', function (e) {
        if (e.target.closest('.wf-gallery-nav')) return; // Pfeile nicht mitfangen
        var activeIndex = galleryBig.swiper ? galleryBig.swiper.activeIndex : 0;
        lightbox.loadAndOpen(activeIndex);
      });

      // Eigene Links/Rechts-Pfeile direkt auf dem Hauptbild (zusätzlich zur
      // Lightbox) – nutzt die bereits laufende Swiper-Instanz der Seite.
      if (galleryBig.swiper && !galleryBig.querySelector('.wf-gallery-nav')) {
        var prevBtn = document.createElement('button');
        prevBtn.type = 'button';
        prevBtn.className = 'wf-gallery-nav wf-prev';
        prevBtn.setAttribute('aria-label', 'Vorheriges Bild');
        prevBtn.innerHTML =
          '<svg viewBox="0 0 24 24"><path d="M15.5 4.5L8 12l7.5 7.5"/></svg>';

        var nextBtn = document.createElement('button');
        nextBtn.type = 'button';
        nextBtn.className = 'wf-gallery-nav wf-next';
        nextBtn.setAttribute('aria-label', 'Nächstes Bild');
        nextBtn.innerHTML =
          '<svg viewBox="0 0 24 24"><path d="M8.5 4.5L16 12l-7.5 7.5"/></svg>';

        prevBtn.addEventListener('click', function (e) {
          e.stopPropagation();
          galleryBig.swiper.slidePrev();
        });
        nextBtn.addEventListener('click', function (e) {
          e.stopPropagation();
          galleryBig.swiper.slideNext();
        });

        galleryBig.appendChild(prevBtn);
        galleryBig.appendChild(nextBtn);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
/* ==========================================================================
   Kleiner Hinweistext unter dem Preis
   ========================================================================== */
(function () {
  'use strict';

  function initPriceNote() {
    var priceEl = document.querySelector('.single_product__price');
    if (!priceEl || document.querySelector('.wf-price-note')) return;
    var note = document.createElement('p');
    note.className = 'wf-price-note';
    note.textContent = 'inkl. MwSt. + kostenlose Lieferung';
    priceEl.insertAdjacentElement('afterend', note);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPriceNote);
  } else {
    initPriceNote();
  }
})();
  (function () {
  'use strict';
  function initCartRow() {
    var qty = document.querySelector('.single_product__quantity');
    var btnBlock = document.querySelector('.button_block');
    if (!qty || !btnBlock || document.querySelector('.wf-cart-row')) return;
    var addBtn = btnBlock.firstElementChild;
    if (!addBtn || !addBtn.classList.contains('btn')) return;

    var handle = window.location.pathname.split('/products/')[1];
    if (!handle) return;
    handle = handle.split('/')[0].split('?')[0];

    fetch('/products/' + handle + '.js')
      .then(function (r) { return r.json(); })
      .then(function (product) {
        var isAccessory = (product.tags || []).some(function (t) {
          return t.indexOf('Zubehör') !== -1;
        });
        if (isAccessory) {
          var row = document.createElement('div');
          row.className = 'wf-cart-row';
          addBtn.parentNode.insertBefore(row, addBtn);
          row.appendChild(qty);
          row.appendChild(addBtn);
        }
      })
      .catch(function () { /* im Zweifel: nichts ändern */ });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCartRow);
  } else {
    initCartRow();
  }
})();

(function () {
  'use strict';
  function initGalleryDots() {
    var big = document.querySelector('.gallery_big');
    if (!big || !big.swiper || document.querySelector('.wf-gallery-dots')) return;
    var count = big.swiper.slides.length;
    if (!count || count <= 1) return;

    var wrap = document.createElement('div');
    wrap.className = 'wf-gallery-dots';
    for (var i = 0; i < count; i++) {
      var dot = document.createElement('span');
      dot.className = 'wf-dot' + (i === big.swiper.activeIndex ? ' active' : '');
      dot.setAttribute('data-index', i);
      wrap.appendChild(dot);
    }
    big.appendChild(wrap);

    wrap.addEventListener('click', function (e) {
      var dot = e.target.closest('.wf-dot');
      if (!dot) return;
      big.swiper.slideTo(parseInt(dot.getAttribute('data-index'), 10));
    });

    big.swiper.on('slideChange', function () {
      var dots = wrap.querySelectorAll('.wf-dot');
      for (var i = 0; i < dots.length; i++) {
        if (i === big.swiper.activeIndex) {
          dots[i].classList.add('active');
        } else {
          dots[i].classList.remove('active');
        }
      }
    });
  }

  function waitForSwiperAndInit(tries) {
    var big = document.querySelector('.gallery_big');
    if (big && big.swiper) {
      initGalleryDots();
      return;
    }
    if (tries > 0) {
      setTimeout(function () { waitForSwiperAndInit(tries - 1); }, 200);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { waitForSwiperAndInit(25); });
  } else {
    waitForSwiperAndInit(25);
  }
})();
/* Thumbnail-Leiste unter dem Hauptbild (Desktop) */
(function () {
  function buildThumbStrip() {
    var gb = document.querySelector('.gallery_big');
    if (!gb || !gb.swiper || document.querySelector('.wf-thumbstrip')) return;
        // Verknüpfung mit der versteckten Thumb-Leiste lösen – sonst springt die
    // Galerie bei jedem resize (Mobile: Adressleiste) auf Bild 1 zurück
    gb.swiper.params.control = undefined;
    var oldThumbs = document.querySelector('.gallery_thumbs');
    if (oldThumbs && oldThumbs.swiper) oldThumbs.swiper.params.control = undefined;
    var slides = Array.prototype.slice.call(gb.querySelectorAll('.swiper-wrapper > .swiper-slide'));
    if (!slides.length) return;
    var strip = document.createElement('div');
    strip.className = 'wf-thumbstrip';
    slides.forEach(function (slide, i) {
      var img = slide.querySelector('img');
      if (!img) return;
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'wf-thumb';
      btn.setAttribute('aria-label', 'Bild ' + (i + 1));
      var t = document.createElement('img');
      var src = img.currentSrc || img.src || '';
      t.src = src.replace(/_(\d+x\d*|\d*x\d+)(_crop_[a-z]+)?\.(jpg|jpeg|png|webp)/i, '_300x.$3');
      t.alt = img.alt || '';
      t.loading = 'lazy';
      btn.appendChild(t);
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        if (gb.swiper) gb.swiper.slideTo(i);
      });
      strip.appendChild(btn);
    });
    gb.insertAdjacentElement('afterend', strip);
    function activeIndex() {
      for (var i = 0; i < slides.length; i++) {
        if (slides[i].classList.contains('swiper-slide-active')) return i;
      }
      return 0;
    }
    function sync() {
      var idx = activeIndex();
      var thumbs = strip.querySelectorAll('.wf-thumb');
      for (var i = 0; i < thumbs.length; i++) thumbs[i].classList.toggle('active', i === idx);
      var a = thumbs[idx];
      if (a) strip.scrollTo({ left: a.offsetLeft - (strip.clientWidth - a.offsetWidth) / 2, behavior: 'smooth' });
    }
    var obs = new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        if (muts[i].attributeName === 'class') { sync(); return; }
      }
    });
    slides.forEach(function (s) { obs.observe(s, { attributes: true, attributeFilter: ['class'] }); });
    sync();
  }
  function waitForThumbStrip(tries) {
    var gb = document.querySelector('.gallery_big');
    if (gb && gb.swiper) { buildThumbStrip(); return; }
    if (tries > 0) setTimeout(function () { waitForThumbStrip(tries - 1); }, 200);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { waitForThumbStrip(50); });
  } else {
    waitForThumbStrip(50);
  }
})();
/* Termin-Button umbenennen */
(function () {
  function renameBookingButton() {
    var btn = document.querySelector('.tpb-book-on-grid-button');
    if (btn && btn.textContent.trim() !== 'Probefahrt in Berlin buchen') {
      btn.textContent = 'Probefahrt in Berlin buchen';
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', renameBookingButton);
  } else {
    renameBookingButton();
  }
  setTimeout(renameBookingButton, 1500);
})();